import { render, staticRenderFns } from "./procurementProcess.vue?vue&type=template&id=68eb0980&scoped=true&"
import script from "./procurementProcess.vue?vue&type=script&lang=js&"
export * from "./procurementProcess.vue?vue&type=script&lang=js&"
import style0 from "./procurementProcess.vue?vue&type=style&index=0&id=68eb0980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eb0980",
  null
  
)

export default component.exports